import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useResolvedPath } from 'react-router-dom';

import { Role, usePutPersonsTenantUserInviteMutation } from '@client/api';
import { Skeleton, useRouteDocumentTitle } from '@client/toolkit';

import { UsersPaths } from '../users.router';
import { UserInviteForm, UserInviteFormData } from '../components/userInvite.form';
import { toast } from 'react-hot-toast';

export function UserCreateRoute() {
  const { t, ready } = useTranslation('tenants');
  const { t: tGlobal } = useTranslation('global');
  const navigate = useNavigate();

  const userCreatePath = useResolvedPath(UsersPaths.UserCreate);
  useRouteDocumentTitle(t('inviteUser'), userCreatePath.pathname);

  const [putPerson] = usePutPersonsTenantUserInviteMutation();

  const handleClose = () => {
    navigate(-1);
  };

  const handleSubmit = async (data: UserInviteFormData) => {
    await putPerson({ body: { email: data.email, role: data.role as Role } })
      .unwrap()
      .then(() => {
        navigate(generatePath(UsersPaths.Users, { replace: true }));
        toast.success(tGlobal('user.userInvitedSuccessfully'));
      });
  };

  return (
    <UserInviteForm
      title={ready ? t('inviteUser') : <Skeleton variant="text" />}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
}
